var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackVector(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 13s-.086-.066-.117-.093C4.406 10.815 0 6.503 0 6.477c.058-.046 3.564-3.44 5.26-5.093L6.682 0C7.128.445 7.564.888 8 1.33v.042c-.03.024-3.505 3.398-5.21 5.06-.028.026-.053.059-.08.092l.092.099c1.696 1.65 3.392 3.302 5.087 4.955.034.032.111.113.111.125L6.667 13z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackVector);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconBackVector.4150576d.svg";
export { MemoForwardRef as ReactComponent };